import { Component, input, output } from "@angular/core";
import { environment } from "@environments/environment";
import {
  RdxSelectComponent,
  RdxSelectContentDirective,
  RdxSelectItemDirective,
  RdxSelectTriggerDirective,
  RdxSelectValueDirective,
} from "@radix-ng/primitives/select";

@Component({
  selector: "app-drop-down",
  imports: [RdxSelectComponent, RdxSelectTriggerDirective, RdxSelectValueDirective, RdxSelectContentDirective, RdxSelectItemDirective],
  template: `
    <div rdxSelect class="drop-down" [disabled]="disabled()">
      <button rdxSelectTrigger class="drop-down__button-trigger" [class]="class()" [attr.aria-label]="label()" [attr.name]="name()">
        <span rdxSelectValue placeholder="homophone"></span>
      </button>

      <div class="drop-down__item-list" rdxSelectContent>
        @for (value of values(); track value) {
          <div
            class="drop-down__item"
            rdxSelectItem
            [value]="value"
            [attr.data-state]="value === selectedValue() ? 'checked' : 'unchecked'"
            (click)="handleValueChange(value)"
          >
            {{ value }}
          </div>
        }
      </div>
    </div>
  `,
  styles: `
    @use "responsive" as *;
    @use "typography" as *;

    .drop-down__button-trigger {
      display: inline-flex;
      align-items: center;
      height: 46px;
      min-width: 155px;
      padding: 0 48px 0 24px;
      border-radius: 20px;

      color: #677484;
      border: 2px solid #d1dde0;
      background: #ffffff;
      box-shadow: 0 4px 0 0 #d1dde0;

      appearance: none;
      background-image: url("${environment.baseRef}/assets/icons/chevron-down.svg");
      background-repeat: no-repeat;
      background-size: 24px 24px;
      background-position: right 16px bottom calc(50% - 1px);
      cursor: pointer;
      position: relative;
      z-index: 1001;
      @include body2();

      @include screenWidth("from-desktop") {
        height: 56px;
        padding-right: 52px;
        background-position: right 20px bottom calc(50% - 1px);
        min-width: 155px;
        @include body1();
      }

      &:hover {
        border-color: #95b0b7;
        box-shadow: 0 4px 0 0 #95b0b7;
      }

      &:focus {
        box-shadow:
          0 0 0 2px #fff,
          0 0 0 6px #2e7b84;
      }

      &[data-state="open"] {
        border-color: #95b0b7;
        box-shadow: none;
        box-shadow:
          0 0 0 2px #fff,
          0 0 0 6px #2e7b84;
      }

      &:disabled {
        opacity: 1;
        cursor: not-allowed;
      }

      &.is-correct {
        color: #152942;
        border-color: #05bf8e;
        background-color: #cdf2e8;
        box-shadow: 0 4px 0 0 #05bf8e;
      }

      &.is-incorrect {
        color: #152942;
        border-color: #ff3614;
        background-color: #ffcfb1;
        box-shadow: 0 4px 0 0 #ff3614;
      }
    }

    .drop-down {
      position: relative;
      display: inline-block;
    }

    .drop-down__item-list {
      position: absolute;
      top: calc(100% - 15px);
      left: 0;
      width: 100%;
      background: #ffffff;
      border: 2px solid #95b0b7;
      border-top: none;
      border-radius: 0 0 20px 20px;
      padding: 20px 5px 5px 5px;
      box-shadow: 0 4px 0 0 #95b0b7;
      max-height: 300px;
      overflow-y: auto;
      z-index: 1000;
    }

    .drop-down__item {
      padding: 7px 20px;
      color: #677484;
      cursor: pointer;
      border-radius: 12px;
      @include body2();

      @include screenWidth("from-desktop") {
        @include body1();
      }

      &:hover,
      &[data-highlighted] {
        background-color: #f0f4f5;
        color: #152942;
      }
    }
  `,
})
export class DropDown {
  values = input.required<string[]>();
  selectedValue = input<string | undefined>();
  label = input<string | undefined>();
  disabled = input<boolean>();
  class = input<string>("");
  name = input.required<string>();

  selectOption = output<string | undefined>();

  handleValueChange(value: string) {
    this.selectOption.emit(value);
  }
}
